import { useState } from "react";
import "./Departments.css";

const data = {
  org: "Zilla Parishad Pune",
  title: "District Rural Development Agency",
  titleMarathi: "जिल्हा ग्रामीण विकास यंत्रणा",
  emblem: "🏘️",
  regNo: "M.A.H.815/Pune/81",
  regDate: "10th September 1981",
  intro: `The District Rural Development Agency (DRDA), Pune implements various central and state sponsored schemes. It is an autonomous organization registered with the Hon'ble Charity Commissioner under the Societies Registration Act, 1860 (Reg. No. M.A.H.815/Pune/81, dated 10th September 1981). The office is committed to eradicating poverty and improving the standard of living of families below the poverty line in rural areas of Pune district.`,
  stats: [
    { value: "1981", label: "Year of Registration" },
    { value: "17", label: "Housing Schemes" },
    { value: "3", label: "Central Other Schemes" },
    { value: "BPL", label: "Primary Beneficiaries" },
    { value: "RTI", label: "Sec 4(1)(b) Compliant" },
    { value: "Pune", label: "District Coverage" },
  ],
  info: [
    { key: "Organization", val: "DRDA, Pune" },
    { key: "Type", val: "Autonomous Body" },
    { key: "Reg. Act", val: "Societies Registration Act, 1860" },
    { key: "Reg. No.", val: "M.A.H.815/Pune/81" },
    { key: "Reg. Date", val: "10 September 1981" },
    { key: "Telephone", val: "020-26131784" },
    { key: "Address", val: "District Level Office" },
  ],
  contact: [
    { icon: "📞", label: "020-26131784" },
    { icon: "🏢", label: "District Level Office" },
    { icon: "🏛️", label: "Zilla Parishad Pune" },
  ],
  services: [
    "BPL Family Welfare Schemes",
    "Housing Scheme Implementation",
    "Poverty Eradication Programs",
    "Rural Skill Development",
    "Women Self-Help Groups",
    "Tribal Area Development",
    "RTI Information (Sec 4(1)(b))",
    "Livelihood Programs",
  ],
  schemeGroups: [
    {
      category: "Central Government — Housing Schemes",
      icon: "🏛️",
      color: "var(--navy)",
      schemes: [
        {
          name: "Pradhan Mantri Awas Yojana – Rural (PMAY-R)",
          desc: "Central government flagship scheme providing financial assistance to rural BPL families for construction of pucca houses with basic amenities.",
          amount: "Central Sponsored",
        },
        {
          name: "PM Janjati Tribal Justice Maha Abhiyan (PM-JANMAN)",
          desc: "Special central scheme focused on Particularly Vulnerable Tribal Groups (PVTGs) for housing, connectivity, and basic infrastructure development.",
          amount: "Central Sponsored",
        },
      ],
    },
    {
      category: "State Government — Housing Schemes",
      icon: "🏠",
      color: "var(--green)",
      schemes: [
        {
          name: "Ramai Housing Scheme",
          desc: "State government housing scheme providing financial assistance to Scheduled Caste families below the poverty line for construction of residential units.",
          amount: "State Sponsored",
        },
        {
          name: "Shabari Housing Scheme",
          desc: "Housing assistance scheme for Scheduled Tribe families to ensure dignified housing and improve living standards in rural areas.",
          amount: "State Sponsored",
        },
        {
          name: "Pardhi Awas Yojana",
          desc: "Targeted housing scheme for the Pardhi community — a denotified tribe — to provide permanent housing and support rehabilitation.",
          amount: "State Sponsored",
        },
        {
          name: "Modi Awas Gharkul Yojana",
          desc: "State housing scheme providing financial support for construction of new homes for eligible rural families identified under poverty criteria.",
          amount: "State Sponsored",
        },
        {
          name: "Yashwantrao Chavan Free Colony Scheme",
          desc: "Scheme to develop residential colonies for economically weaker rural families, providing free housing plots or dwelling units.",
          amount: "State Sponsored",
        },
        {
          name: "Atal Kamgar Awas Yojana",
          desc: "Housing scheme for construction workers and labour class families to provide affordable residential accommodation.",
          amount: "State Sponsored",
        },
        {
          name: "Pandit Deendayal Upadhyay Gharkul Space Purchase Assistance Scheme",
          desc: "Financial assistance scheme for eligible rural families to purchase residential land/plot for construction of their own dwelling.",
          amount: "State Sponsored",
        },
        {
          name: "Punyashlok Ahilya Devi Holkar Gharkul Yojana",
          desc: "Housing scheme named after Punyashlok Ahilya Devi Holkar, providing support to marginalized rural families for home construction.",
          amount: "State Sponsored",
        },
      ],
    },
    {
      category: "Zilla Parishad — Housing Schemes",
      icon: "🏗️",
      color: "var(--gold)",
      schemes: [
        {
          name: "Yashwant Gharkul Yojana",
          desc: "Zilla Parishad sponsored housing scheme providing financial assistance for construction of dwelling units for identified BPL rural households.",
          amount: "ZP Sponsored",
        },
        {
          name: "Divyang Gharkul Scheme",
          desc: "Dedicated housing scheme for persons with disabilities (Divyang) to ensure accessible and suitable housing in rural areas.",
          amount: "ZP Sponsored",
        },
      ],
    },
    {
      category: "Central Government — Other Schemes",
      icon: "📋",
      color: "var(--saffron)",
      schemes: [
        {
          name: "Umed (MSRLM — Maharashtra State Rural Livelihoods Mission)",
          desc: "Promotes rural livelihoods through Self-Help Groups (SHGs), financial inclusion, skill training, and enterprise development for BPL rural women and families.",
          amount: "Central Sponsored",
        },
        {
          name: "Sant Sevalal Maharaj Banjara / Laman Tanda Prosperity Scheme",
          desc: "Comprehensive development scheme for Banjara/Laman Tanda communities focusing on education, livelihood, housing, and infrastructure in tribal settlements.",
          amount: "Central Sponsored",
        },
        {
          name: "DDUGKY — Deendayal Upadhyay Rural Skill Scheme",
          desc: "Skill development scheme for rural youth to enhance employability through vocational training, placement support and linkage to industry for sustainable livelihoods.",
          amount: "Central Sponsored",
        },
      ],
    },
  ],
  tabs: ["Overview", "Housing Schemes", "Other Schemes", "Services", "Contact"],
};

export default function DRDAVibhag() {
  const [activeTab, setActiveTab] = useState("Overview");

  return (
    <div>
      {/* Top Strip */}
      <div className="dept-top-strip">
        <span>🏘️ District Rural Development Agency — Zilla Parishad Pune</span>
        <span>📞 020-26131784</span>
      </div>

      {/* Header */}
      <div className="dept-header">
        <div className="dept-header-emblem">{data.emblem}</div>
        <div className="dept-header-text">
          <div className="dept-header-org">{data.org}</div>
          <div className="dept-header-title">{data.title}</div>
          <div className="dept-header-subtitle">{data.titleMarathi}</div>
        </div>
        <div className="dept-header-badge">Autonomous Body</div>
      </div>

      {/* Nav Tabs */}
      <div className="dept-nav">
        {data.tabs.map((tab) => (
          <button
            key={tab}
            className={`dept-nav-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Main Content */}
      <div className="dept-main">

        {/* Intro Hero */}
        <div className="dept-intro">
          <div className="dept-intro-label">About the Agency</div>
          <div className="dept-intro-text">
            {data.intro}
            <br /><br />
            <strong>Registration:</strong> Societies Registration Act, 1860 &nbsp;|&nbsp;
            <strong>Reg. No.:</strong> {data.regNo} &nbsp;|&nbsp;
            <strong>Date:</strong> {data.regDate}
          </div>
        </div>

        {/* Stats Row */}
        <div className="dept-stats">
          {data.stats.map((s, i) => (
            <div className="dept-stat-card" key={i}>
              <div className="dept-stat-value">{s.value}</div>
              <div className="dept-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* All Scheme Groups */}
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          {data.schemeGroups.map((group, gi) => (
            <div className="dept-section" key={gi}>
              <div className="dept-section-header">
                <div
                  className="dept-section-icon"
                  style={{ background: `${group.color}18`, color: group.color }}
                >
                  {group.icon}
                </div>
                <div className="dept-section-title">{group.category}</div>
              </div>
              <div className="scheme-list">
                {group.schemes.map((scheme, i) => (
                  <div
                    className="scheme-card"
                    key={i}
                    style={{ "--scheme-accent": group.color }}
                  >
                    <div className="scheme-card-name">{scheme.name}</div>
                    <div className="scheme-card-desc">{scheme.desc}</div>
                    <span
                      className="scheme-card-amount"
                      style={{
                        background:
                          group.color === "var(--navy)"
                            ? "#e8edf5"
                            : group.color === "var(--gold)"
                            ? "var(--gold-light)"
                            : group.color === "var(--saffron)"
                            ? "var(--saffron-light)"
                            : "var(--green-light)",
                        color: group.color,
                      }}
                    >
                      {scheme.amount}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Sidebar */}
        <div className="dept-sidebar">

          {/* Department Info */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Agency Details</div>
            {data.info.map((row, i) => (
              <div className="dept-info-row" key={i}>
                <span className="dept-info-key">{row.key}</span>
                <span className="dept-info-val">{row.val}</span>
              </div>
            ))}
          </div>

          {/* RTI Highlight */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">RTI Compliance</div>
            <div className="dept-highlight-box">
              <div className="dept-highlight-box-title">📜 Right to Information Act 2005</div>
              <p>
                Information on items 1 to 17 as per Section 4(1)(b) of the Right to Information Act 2005 is available at the District Level Office and through official channels.
              </p>
            </div>
          </div>

          {/* Services */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Key Services</div>
            <div className="dept-services-grid">
              {data.services.map((s, i) => (
                <div className="dept-service-item" key={i}>{s}</div>
              ))}
            </div>
          </div>

          {/* Scheme Count Summary */}
          <div className="dept-info-card">
            <div className="dept-info-card-title">Scheme Summary</div>
            {[
              { label: "Central Housing Schemes", count: "2", color: "var(--navy)" },
              { label: "State Housing Schemes", count: "8", color: "var(--green)" },
              { label: "ZP Housing Schemes", count: "2", color: "var(--gold)" },
              { label: "Central Other Schemes", count: "3", color: "var(--saffron)" },
            ].map((item, i) => (
              <div className="dept-info-row" key={i}>
                <span className="dept-info-key">{item.label}</span>
                <span
                  className="dept-info-val"
                  style={{
                    background: `${item.color}18`,
                    color: item.color,
                    padding: "2px 10px",
                    borderRadius: "12px",
                    fontWeight: 700,
                  }}
                >
                  {item.count}
                </span>
              </div>
            ))}
          </div>

          {/* Contact */}
          <div className="dept-contact-card">
            <div className="dept-contact-card-title">Contact Information</div>
            {data.contact.map((c, i) => (
              <div className="dept-contact-row" key={i}>
                <span>{c.icon}</span>
                <span>{c.label}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Footer */}
      <div className="dept-footer">
        <strong>Zilla Parishad Pune</strong> — District Rural Development Agency &nbsp;|&nbsp;
        Reg. No. M.A.H.815/Pune/81 &nbsp;|&nbsp; Telephone: 020-26131784
      </div>
    </div>
  );
}
